import axios from '../Axios/Default';
import { handleResponse } from '../Utils/Utils';

export const getAllAssembles = (_params, onSuccess, onError) => {
    const response = axios.get(`v1/admin/assemble`, { params: _params });
    return handleResponse(response, onSuccess, onError)
}
export const createAssembly = (data, onSuccess, onError) => {
    const request = axios.post(`v1/admin/assemble`, data);
    return handleResponse(request, onSuccess, onError);
}
export const updateAssembly = (id, data, onSuccess, onError) => {
    const request = axios.put(`v1/admin/assemble/${id}`, data);
    return handleResponse(request, onSuccess, onError);
}
export const deleteAssembly = (id, onSuccess, onError) => {
    const request = axios.delete(`v1/admin/assemble/${id}`);
    return handleResponse(request, onSuccess, onError);
}
export const softDeleteAssembly = (id, data, onSuccess, onError) => {
    const request = axios.put(`v1/admin/assemble/${id}/delete`, data);
    return handleResponse(request, onSuccess, onError);
}